module.exports = __webpack_public_path__ + "img/layout-6_7.59f8ea00.png";